var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    staticClass: "d-flex flex-column align-center mb-12 rounded-lg"
  }, [_c('h1', {
    staticClass: "text-h2 text-center primary--text font-weight-bold"
  }, [_vm._v("Discount Tickets")]), _c('v-card', {
    staticClass: "mt-12",
    attrs: {
      "max-width": "850",
      "width": "100%"
    }
  }, [_c('v-card-text', {
    staticClass: "primary--text"
  }, [_c('img', {
    staticClass: "d-block mx-auto mt-4 mb-12",
    attrs: {
      "height": "150px",
      "width": "150px",
      "src": "https://media.eipl.org/site/images/tickets/admit-one.png"
    }
  }), _c('p', {
    staticClass: "text-body-1 primary--text font-weight-black mb-2"
  }, [_vm._v("The library offers tickets to a variety of local attractions at a discounted rate for our patrons.")]), _c('p', {
    staticClass: "primary--text text--lighten-2 font-weight-bold"
  }, [_vm._v("* Please note some locations require a reservation date or special instructions when purchased.")]), _c('ul', {
    staticClass: "primary-text py-4"
  }, [_c('li', [_vm._v("Patrons must have an adult East Islip Library Card to purchase discount tickets.")]), _c('li', [_vm._v("These tickets are available at the Library's Circulation Desk.")]), _c('li', [_vm._v("There is a limit of 6 tickets per family, per month.")])])]), _c('v-card-actions', {
    staticClass: "primary--text text-center"
  }, [_c('v-btn', {
    staticClass: "mx-2",
    attrs: {
      "color": "primary",
      "outlined": "",
      "to": "/services/museum-passes"
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-bank")]), _vm._v("MUSEUM PASSES")], 1), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("are also available!")])], 1)], 1), _c('v-sheet', {
    staticClass: "my-8",
    attrs: {
      "color": "transparent"
    }
  }), _vm._l(_vm.tickets, function (ticket) {
    return _c('card-discount-ticket', {
      key: ticket.slug,
      attrs: {
        "ticket": ticket
      }
    });
  }), _c('v-sheet', {
    staticClass: "my-8",
    attrs: {
      "color": "transparent"
    }
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }